export default {
    created() {
        // 分享
        EVENTHUB.on('share', callback => {
            callback('scenario', this.scenarioIndex)
        })
        // 绑定分享
        this.$ShareData.bind('scenario', index => {
            this.scenarioIndex = index
        })
    }
}
